import React, { useEffect, useState } from "react";
import Logo from "../../assets/images/DocuVerusLogoorg.png";

import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { FormProvider, useForm } from "react-hook-form";
// import { toast, ToastContainer } from "react-toastify";
import { Outlet, Link, useNavigate, Navigate } from "react-router-dom";
import InputField2 from "../../componets/common/InputComponents/InputField2";
import { Button, useCreate, useNotify, useRefresh } from "react-admin";
import { CircularProgress } from "@mui/material";
import { useLogin, Notification } from "react-admin";
import { SOFTWARE_VERSION } from "../../config";
import { JSONTree } from "react-json-tree";

const ForgotPassword = (props) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState(" ");
  const [create, { isLoading, error }] = useCreate();

  const schema = yup.object().shape({
    email: yup.string()
      .typeError("Email is required!")
      .matches(/^$|^\S+.*/g, "Enter a valid value")
      .required("Email is required!")
      .matches(/^[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/, "Invalid email format"),
  });

  // Initial form values
  const defaultFormValues = {
    email: "",
  };

  const methods = useForm({
    defaultValues: defaultFormValues,
    resolver: yupResolver(schema),
    mode: "onChange",
  });



  useEffect(() => {
    document.title = "Docuverus";
  }, []);

  const onSubmit = (data) => {
    const sendData = {
      email: data?.email,
    };
    create(
      "forgotPassword",
      { data: sendData },
      {
        onSuccess: (data) => {
          notify(`${data?.message}`, {
            type: "success",
            anchorOrigin: { vertical: "top", horizontal: "right" },
          });
          setErrorMessage("");
          methods?.reset();
        },
        onError: (e: any) => {
          // notify(`Operation fail: ${e.message}`, {
          //   type: "error",
          //   anchorOrigin: { vertical: "top", horizontal: "right" },
          // });
          setErrorMessage(`${e.message}`);
        },
      }
    );
  };
  return (
    <section className="login-wrap">
      {/* <div className="alert alert-warning alert-dismissible fade show" role="alert">
        <strong>Docuverus has released our 4.0 upgrade!</strong> Please <a href="#" onClick={(e) => {
          e.preventDefault(); localStorage.clear(); setTimeout(() => {
            window.location.href = 'https://app.dvapply.com/'
          }, 300)
        }}>click this</a> to reset your browser cache. You will not need to do this again. We apologize for the inconvenience.
        <button type="button" className="btn close" data-dismiss="alert" aria-label="Close">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x-circle-fill" viewBox="0 0 16 16">
            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293z" />
          </svg>
        </button>
      </div> */}
      <div className="login-cell">
        <div className="login-block">
          <div className="l-logo-block text-center">
            <img src={Logo} alt="Docuverus" title="Docuverus" />
          </div><br />
          {errorMessage && <p style={{ color: "red", textAlign: 'center', fontSize: '12px', fontWeight: 'bold' }} >{errorMessage}</p>}

          <div className="auth-form mr-t30">
            <FormProvider {...methods}>
              <form onSubmit={methods.handleSubmit(onSubmit)}>
                <div className="form-group cus-input-group mr-b20">

                  <InputField2
                    label="Email"
                    source={`email`}
                    placeholder="Enter Email Here"
                    labelClass={"lable-title"}
                    additionalInputClass={"cus-control"}
                  />
                </div>
                {isLoading ? (
                  <div className="static-d-info d-flex justify-content-center align-items-center mw-100">
                    <CircularProgress size="20px" />
                    <h5>&nbsp; &nbsp; Please wait...</h5>
                  </div>
                ) : (
                  <div className="d-flex justify-content-center align-items-center">
                    <button type="submit" className="l-btn-forgetPsd">
                      Reset Password
                    </button>
                  </div>
                )}
              </form>
              <br />
              <div className="w-full p-t-3 p-b-5 d-flex justify-content-end">
                <Link to="/" className="txt1" style={{ color: "5555FF" }}>
                  Back to Login
                </Link>
              </div>
            </FormProvider>
          </div>
          <div className="l-foot-links mr-t20" >
            <ul className="mx-auto">
              <li></li>
              <li></li>
              <li >Version {SOFTWARE_VERSION}</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ForgotPassword;
